import { gql } from '@apollo/client/core';

import { ORDER_FIELDS } from '@/entities/order';

import { ORDER_FISCAL_EXECUTION_FIELDS } from './order-fiscalization.fragments.graphql';

export const GET_ORDER_FISCAL_SETTLEMENT_OPERATION = gql`
  ${ORDER_FISCAL_EXECUTION_FIELDS}

  query GetOrderFiscalSettlementOperation($orderId: ID!) {
    orderFiscalSettlementOperation(orderId: $orderId) {
      ...OrderFiscalExecutionFields
    }
  }
`;

export const PREPARE_ORDER_FISCAL_SETTLEMENT = gql`
  ${ORDER_FISCAL_EXECUTION_FIELDS}

  mutation PrepareOrderFiscalSettlement($input: PrepareOrderFiscalSettlementInput!) {
    prepareOrderFiscalSettlement(input: $input) {
      ...OrderFiscalExecutionFields
    }
  }
`;

export const START_ORDER_FISCAL_SETTLEMENT = gql`
  ${ORDER_FISCAL_EXECUTION_FIELDS}

  mutation StartOrderFiscalSettlement($input: OrderFiscalOperationIdentityInput!) {
    startOrderFiscalSettlement(input: $input) {
      ...OrderFiscalExecutionFields
    }
  }
`;

export const COMPLETE_ORDER_FISCAL_SETTLEMENT = gql`
  ${ORDER_FIELDS}
  ${ORDER_FISCAL_EXECUTION_FIELDS}

  mutation CompleteOrderFiscalSettlement($input: CompleteOrderFiscalSettlementInput!) {
    completeOrderFiscalSettlement(input: $input) {
      order {
        ...OrderFields
      }
      execution {
        ...OrderFiscalExecutionFields
      }
    }
  }
`;

export const FAIL_ORDER_FISCAL_SETTLEMENT = gql`
  ${ORDER_FIELDS}
  ${ORDER_FISCAL_EXECUTION_FIELDS}

  mutation FailOrderFiscalSettlement($input: FailOrderFiscalSettlementInput!) {
    failOrderFiscalSettlement(input: $input) {
      order {
        ...OrderFields
      }
      execution {
        ...OrderFiscalExecutionFields
      }
    }
  }
`;

export const RETRY_ORDER_FISCAL_RECEIPT = gql`
  ${ORDER_FISCAL_EXECUTION_FIELDS}

  mutation RetryOrderFiscalReceipt($input: RetryOrderFiscalReceiptInput!) {
    retryOrderFiscalReceipt(input: $input) {
      ...OrderFiscalExecutionFields
    }
  }
`;

export const RESOLVE_ORDER_FISCAL_RECEIPT = gql`
  ${ORDER_FIELDS}
  ${ORDER_FISCAL_EXECUTION_FIELDS}

  mutation ResolveOrderFiscalReceipt($input: ResolveOrderFiscalReceiptInput!) {
    resolveOrderFiscalReceipt(input: $input) {
      order {
        ...OrderFields
      }
      execution {
        ...OrderFiscalExecutionFields
      }
    }
  }
`;

export const ANSWER_ORDER_FISCAL_RECEIPT_PRINTED = gql`
  ${ORDER_FIELDS}
  ${ORDER_FISCAL_EXECUTION_FIELDS}

  mutation AnswerOrderFiscalReceiptPrinted($input: AnswerOrderFiscalReceiptPrintedInput!) {
    answerOrderFiscalReceiptPrinted(input: $input) {
      order {
        ...OrderFields
      }
      execution {
        ...OrderFiscalExecutionFields
      }
    }
  }
`;

export const CANCEL_ORDER_FISCAL_PAYMENT = gql`
  mutation CancelOrderFiscalPayment($input: CancelOrderFiscalPaymentInput!) {
    cancelOrderFiscalPayment(input: $input) {
      id
      status
      failure_kind
      bank_payment_status
      failed_at
      cash_amount
    }
  }
`;
